"use client";
import Link from "~/components/Link";
import { normalizeCategoryForUrl } from "~/lib/lyrics.shared";

// Import icons for keywords
import getTagPalette from "./VersuriKeywordIcons";

import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import type { ComponentType } from "react";
import type { LyricsChipTagType } from "~/types";

interface LyricKeywordChipLinkProps {
  category: string;
  type: LyricsChipTagType;
  variant?: "chip" | "tile";
}

// helper moved to VersuriKeywordUtils

export default function LyricKeywordChipLink({
  category,
  type,
  variant,
}: LyricKeywordChipLinkProps) {
  const palette = getTagPalette(type, category);
  const Icon = palette.icon as ComponentType | undefined;

  const chipProps = {
    icon: Icon ? <Icon /> : undefined,
    sx: {
      fontSize: "0.8rem",
      height: 28,
      cursor: "pointer",
      bgcolor: palette.color,
      color: palette.contrastText,
      fontWeight: 500,
      "& .MuiChip-icon": {
        color: palette.contrastText,
        fontSize: "1rem",
      },
      "&:hover": {
        bgcolor: palette.hoverColor,
      },
    },
  };

  if (variant === "tile") {
    return (
      <Link
        href={`/versuri/categorii/${normalizeCategoryForUrl(category)}`}
        effect="none"
        sx={{
          bgcolor: "background.paper",
          borderRadius: 2,
          minHeight: 56,
          cursor: "pointer",
          gap: 2,
          minWidth: { xs: "auto", sm: 250 },
          pl: 1,
          pr: 2,
          position: "relative",
          display: "flex",
          alignItems: "center",
          "&:hover": {
            bgcolor: "action.hover",
          },
        }}
      >
        <Box sx={{
          width: 8,
          borderRadius: 2,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          bgcolor: palette.color,
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
        }} />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, pl: "8px", ml: 1 }}>
          <Typography
            component="span"
            sx={{
              display: "block",
              fontWeight: 500,
              fontSize: "0.95rem"
            }}>{category}</Typography>
          <Box sx={{ flexGrow: 1 }} />
          {Icon && (
            <Box sx={{ color: palette.color, display: "flex", alignItems: "center" }}>
              <Icon />
            </Box>
          )}
        </Box>
      </Link>
    );
  }

  return (
    <Link
      href={`/versuri/categorii/${normalizeCategoryForUrl(category)}`}
      style={{ textDecoration: "none" }}
    >
      <Chip
        label={category}
        size="small"
        component="div"
        clickable
        {...chipProps}
      />
    </Link>
  );
}
